module.exports = __webpack_public_path__ + "img/discard-hand.cd1bea63.svg";